









































import Vue, { PropType } from "vue";
import { formatAsMoney } from "../../../../helpers/format";
import HttpClientFactory from "../../../../services/HttpClientFactory";
import { ValidationObserver } from "vee-validate";
import { snakeCase } from "lodash";
import HttpClient from "../../../../services/HttpClient";
import Invoice from "../../../../types/invoices/Invoice";
import InvoiceLine from "../../../../types/invoices/InvoiceLine";
import ApiInvoiceRequest from "../../../../types/invoices/api/ApiInvoiceRequest";
import moment from "moment";

export default Vue.extend({
  name: "create-invoices-form-final",
  props: {
    invoiceData: {
      type: Object as PropType<Invoice>,
    },
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      lines: [] as InvoiceLine[],
    };
  },
  methods: {
    moneyFormatter: function (value: number) {
      return formatAsMoney(value, "EUR", this.$i18n.i18next.language);
    },
    async validate() {
      const result = await (
        this.$refs.formFinal as InstanceType<typeof ValidationObserver>
      ).validate();
      if (result) {
        this.createInvoice();
      }
    },
    createInvoice() {
      const transformedData: ApiInvoiceRequest = {
        receiverId: this.invoiceData.receiver.id,
        invoiceDateAt: moment(this.invoiceData.invoiceDateAt).format(
          "YYYY-MM-DD"
        ),
        invoiceNumber: this.invoiceData.invoiceNumber,
        dueDateAt: moment(this.invoiceData.dueDateAt).format("YYYY-MM-DD"),
        description: this.invoiceData.description,
        priceWithoutVatAndTaxes:
          this.invoiceData.priceWithoutVatAndTaxes.intValue,
        vat: this.invoiceData.vat.intValue,
        grandTotal: this.invoiceData.grandTotal.intValue,
        lines: this.invoiceData.lines.map((line: InvoiceLine) => ({
          description: line.description,
          qty: line.qty,
          unit: line.unit,
          price: line.price.intValue,
          vat: line.vat,
          totalVat: line.totalVat.intValue,
        })),
      };

      if (transformedData.lines.length === 0) {
        const error: any = {
          text: this.$t("invoices:validate.lines_empty"),
          type: "error",
        };
        this.$notify(error);
      }
      this.httpClient = HttpClientFactory.getInstance();
      this.httpClient
        .post(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/invoice/v1",
          transformedData
        )
        .then(() => {
          const success: any = {
            text: this.$t("invoices:created"),
            type: "success",
          };

          this.$notify(success);

          setTimeout(() => this.$router.push("/dashboard"), 2000);
        })
        .catch((e: any) => {
          const errorCode: string = e.response.data.code;
          const arrayOfErrors: any[] = e.response.data.errors;

          if (arrayOfErrors !== undefined) {
            arrayOfErrors.forEach((error: any) => {
              this.showValidationError(
                snakeCase(error.field),
                snakeCase(error.rule)
              );
            });
          }
          this.showGenericError(errorCode, "warn");
        });
    },
    showGenericError(code: string, type: string) {
      const error: any = {
        text: this.$t(`receiver:${code}`),
        type,
      };
      this.$notify(error);
    },
    showValidationError(field: string, rule: string) {
      const error: any = {
        text: this.$t("invoices:validate." + field + "." + rule),
        type: "error",
      };
      this.$notify(error);
    },
  },
});
